export default {
  title: 'Chiffres clés de votre imposition',
  subtitle: "Pour vos revenus de l'année {year}",
  houseHold: {
    title: 'VOTRE FOYER FISCAL',
    maritalStatus: 'Statut marital',
    parts: 'Parts du foyer fiscal',
    childs: 'Enfants rattachés au foyer fiscal',
  },
  annualTaxes: {
    title: 'Vos impositions annuelles',
    income: 'Impôt sur le revenu (IR)',
    socialLevies: 'Prélèvements sociaux',
    cehr: 'CEHR',
    realEstate: 'Impôt sur la fortune immobilière (IFI)',
    annualTotal: 'Total de vos impositions annuelles',
    pressure: 'Pression fiscale',
  },
}
